module.exports = __webpack_public_path__ + "img/showImg3.e63eadca.png";